module.exports = __webpack_public_path__ + "media/images/mypage/icon/black/ico_location-f0ad5b4d1c74be07f838cb92384acf2a.svg";